<template>
  <div class="n1">
    <h1 class="n1-title">{{title}}</h1>
    <p class="n1-info">{{info}}</p>
    <div class="n1-content">
      <ul>
        <li v-for="(item,index) of logoList" :key="index">
          <div class="n1-bg">
            <tiny-image v-if="item.imgUrls.length > 0" :src="item.imgUrls.split(',')[0]" fit="cover" style="height: 100%;width: 100%"></tiny-image>
          </div>
          <p class="n1-bg-caption">{{item.title}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  Image
} from '@opentiny/vue'
import request from '@/utils/request'

export default {
  name: "HomePart6",
  components: {
    TinyImage: Image,
  },
  props:['info'],
  data() {
    return {
      currentEnter: null,
      currentLeave: null,
      title: "合作伙伴",
      logoList: []
    };
  },
  created() {
    this.queryCompanyInfo();
  },
  methods: {
    async queryCompanyInfo() {
      const {data} = await request.get("/outSiteMenu/queryCustomersList")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.logoList = data.data;
      }
    },
  },
  
};
</script>

<style scoped>
.n1 {
  text-align: center;
  margin-top: 100px;
}
h1 {
  position: relative;
  display: inline-block;
  margin: 0 auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
}
h1::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}
h1::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}
.n1-bg {
  width: 150px;
  height: 100px;
  display: block;
  margin: auto;
  background-size: cover;
  background-position: 0 140px;
}
.n1-bg-enter {
  animation: enter 400ms steps(25) both;
}
.n1-bg-leave {
  animation: leave 400ms steps(25) both;
}
 .n1-content {
  padding: 20px 0 50px;
}
.n1-content::after {
  content: "";
  clear: both;
  display: block;
}

.n1-content ul {
  margin: 20px auto;
  width: 1180px;
}
.n1-content ul li {
  float: left;
  width: 194px;
  padding: 20px 20px 0;
  border: 1px solid #e6e6e6;
}
.n1-content ul li:hover {
  font-weight: 700;
}
.n1-bg-caption {
  position: relative;
  display: inline-block;
  font-size: 18px;
  color: #383e63;
  line-height: 25px;
  margin-top: 10px;
  margin-bottom: 40px;
}
@keyframes enter {
  0% {
    background-position: 0 140px;
  }
  90% {
    background-position: 0 3640px;
  }
  100% {
    background-position: 0 3640px;
  }
}
@keyframes leave {
  0% {
    background-position: 0 3640px;
  }
  90% {
    background-position: 0 140px;
  }
  100% {
    background-position: 0 140px;
  }
}
</style>


